export default __webpack_public_path__ + "static/ai-marketing-4-e4203bafc33594f01e1f2b56127e4c99.png";